import styled from "@emotion/styled";

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;
